import React from 'react'
import makeStyles from '@mui/styles/makeStyles'
import { IconButton, Paper, Theme } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import { IAction } from '../../../../../../../../api/types/action'
import { extractMessage } from '../../../../../../../../utils'
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined'
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { mutationApproveAction, mutationRejectAction } from '../../../../../../../../api/mutations'
import { pendingActionsQueryKey } from '../../../../../../../../api/queries'
import { useGlobalError } from '../../../../../../../../context/GlobalError'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(0.5),
      margin: theme.spacing(0.5),
      display: 'flex',
      justifyItems: 'space-between',
    },
    message: {
      flexGrow: 1,
      marginRight: theme.spacing(1),
    },
  })
)

interface Props {
  action: IAction
}

function parseActionMessage(action: IAction) {
  if (action.action_type === 'modify_hp') {
    return 'zmodyfikować punkty życia o ' + action.params
  }
  if (action.action_type === 'modify_mp') {
    return 'zmodyfikować punkty skupienia o ' + action.params
  }
  if (action.action_type === 'identify_item') {
    return 'zidentyfikować przedmiot ' + ((action.params && JSON.parse(action.params).name) || '')
  }

  return ''
}

export const ActionApproval: React.FC<Props> = ({ action }) => {
  const classes = useStyles()
  const { addError } = useGlobalError()
  const queryClient = useQueryClient()

  const { mutate: approveActionMutation, isLoading: isApproving } = useMutation(
    () => mutationApproveAction(action.id),
    {
      onError: (err: any) => {
        addError(extractMessage(err) || 'Nie udało się zaakceptować akcji', err?.status)
      },
      onSuccess: async () => {
        queryClient.invalidateQueries(pendingActionsQueryKey(action.game_id))
      },
    }
  )
  const { mutate: rejectActionMutation, isLoading: isRejecting } = useMutation(
    () => mutationRejectAction(action.id),
    {
      onError: (err: any) => {
        addError(extractMessage(err) || 'Nie udało się odrzucić akcji', err?.status)
      },
      onSuccess: async () => {
        queryClient.invalidateQueries(pendingActionsQueryKey(action.game_id))
      },
    }
  )

  return (
    <>
      <Paper className={classes.root}>
        <div className={classes.message}>
          <strong>{action.character.name}</strong> chce {parseActionMessage(action)}
        </div>
        <div>
          <IconButton
            size="small"
            style={{ color: 'green' }}
            disabled={isApproving}
            onClick={() => approveActionMutation()}
          >
            <CheckOutlinedIcon sx={{ height: 16, width: 16 }} />
          </IconButton>
          <IconButton
            size="small"
            style={{ color: 'red' }}
            disabled={isRejecting}
            onClick={() => rejectActionMutation()}
          >
            <ClearOutlinedIcon sx={{ height: 16, width: 16 }} />
          </IconButton>
        </div>
      </Paper>
    </>
  )
}
